import React, { useEffect, useRef } from "react";
import { useFormik } from "formik";
import emailjs from '@emailjs/browser';
import "./Feedback.css";
import { signUpSchema } from "../../schemas";
import AOS from "aos";
function Feedback() {
  const initialValues = {
    name: "",
    email: "",
    message: "",
  };

  function addClass() {
    document
      .getElementsByClassName("feedback-outermost")[0]
      .classList.add("sent");
    // console.log("send button");
  }

  var animateButton = function (e) {

    // e.preventDefault;
    //reset animation
    e.target.classList.remove('animate');

    e.target.classList.add('animate');
    setTimeout(function () {
      e.target.classList.remove('animate');
    }, 700);
  };

  var bubblyButtons = document.getElementsByClassName("bubbly-button");

  for (var i = 0; i < bubblyButtons.length; i++) {
    bubblyButtons[i].addEventListener('mouseover', animateButton, false);
  }

  const form = useRef();

  // const sendEmail = (e) => {
  //   e.preventDefault();

  //   emailjs.sendForm('service_gtp8tgo', 'template_wlt78jc', form.current, 'NpPOHgWnrIkMM-DCH')
  //     .then((result) => {
  //         console.log(result.text);
  //     }, (error) => {
  //         console.log(error.text);
  //     });
  //     e.target.reset();
  // };

  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues: initialValues,

      validationSchema: signUpSchema,
      onSubmit: (values, action) => {
        console.log(values);
        action.resetForm();
        addClass()

        emailjs.sendForm('service_gtp8tgo', 'template_wlt78jc', form.current, 'NpPOHgWnrIkMM-DCH')
          .then((result) => {
            console.log(result.text);
          }, (error) => {
            console.log(error.text);
          });

      },
    });


  return (
    <div className="feedback-outermost">

      <div className="feedback-donate">
        <div className="donate-text">
          <p>Today, many children are not getting the nutrition they need to survive and thrive. At least one in three children under 5 is affected by malnutrition in its most visible forms: stunting, wasting and overweight. Please extend your hands for this Social Cause.</p>
        </div>
        <div className="bubbly-button ">
          <button > <a href="https://www.ketto.org/fundraiser/spreading-love-and-happiness-on-christmas-and-new-year" target={"_blank"}><i style={{ transform: `scale(1.25)` }} className="fa-solid fa-hand-holding-heart"></i> &nbsp; Donate</a> </button>
        </div>
      </div>

      <div className="feedback-innerbox ">
        <div className="form-box">
          <form onSubmit={(e) => { handleSubmit(e) }} ref={form} className="letter">
            <div className="side">
              <h1 data-aos="fade-left">Your feedback</h1>
              <div className="input-box">
                <textarea
                  name="message"
                  type="text"
                  value={values.message}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Your message"
                ></textarea>
                {errors.message && touched.message ? (
                  <p className="form-error">{errors.message}</p>
                ) : null}
              </div>
            </div>
            <div className="side">
              <div className="input-box">
                <input
                  name="name"
                  type="text"
                  value={values.name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Your name"
                />
                {errors.name && touched.name ? (
                  <p className="form-error">{errors.name}</p>
                ) : null}
              </div>
              <div className="input-box">
                <input
                  name="email"
                  type="email"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Your email"
                />
                {errors.email && touched.email ? (
                  <p className="form-error">{errors.email}</p>
                ) : null}
              </div>
              <div className="input-box">
                <button type="submit" id="sendLetter">
                  Send
                </button>
              </div>
            </div>
          </form>
          <div className="envelope front"></div>
          <div className="envelope back"></div>
        </div>
        <div className="result">
          <p className="result-message">Thank you for your message</p>
        </div>
      </div>
    </div>
  );
}

export default Feedback;
